import {createGrid} from "../../helpers/grids/grids";
import {loading, stopLoading} from "../../helpers/loading";
import createElement from "../../helpers/createElement";
import {createCellRenderer, createDoubleClickHandler,} from "../../helpers/grids/helpers";
import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initClientAccountIndex() {
	createGrid('.accounts-grid', {
			columnDefs: [
				{
					field: "name",
					headerName: 'Name',
					sortable: true,
				},
				{
					field: "email",
					headerName: 'Email',
					sortable: true,
				},
				{
					field: "enabled",
					headerName: 'Status',
					sortable: true,
					cellRenderer: createCellRenderer(params => {
						const enabled = params.data.enabled;

						return `<span class="badge mono badge-${enabled ? 'primary' : 'dark'}">${enabled ? 'Enabled' : 'Disabled'}</span>`
					})
				},
				{
					field: "public_id",
					headerName: '',
					maxWidth: 280,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const editRoute = params.data.editRoute;

						const buttons = createElement(`
							<div class="buttons">
                                <a
                                	class="btn btn-primary btn-sm ${!editRoute ? 'disabled' : ''}" href="${editRoute}"

                                >
                                    <i class="fa-solid fa-file-import"></i>
                                    View Account
								</a>
								<button type="button" class="btn btn-danger btn-sm remove-account-button">
                                    <i class="fa-solid fa-trash"></i>
                                    Remove
                                </button>
                            </div>
						`);

						buttons.querySelector('.remove-account-button')
							.addEventListener('click', () => {
								removeAccount(params.data);
							})

						return buttons;
					})
				},
			],

			onRowDoubleClicked: createDoubleClickHandler(data => {
				// noinspection JSUnresolvedVariable
				if (data.editRoute) {
					loading();
					window.location.href = data.editRoute
				}
			}),

			rowClass: 'cursor-pointer',
			paginationPageSize: 20,
			_rowName: 'Accounts',
		},
		window['routes/admin.client-accounts.grid']
	);

	function removeAccount(account) {
		swalConfirm({
			title: 'Are you sure you want to delete this account?'
		}).then(result => {
			if (result.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(account.deleteRoute, {})
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}
}

export {initClientAccountIndex}
